'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var debug = require('debug');

var log = Object.assign(debug('libp2p:transports'), {
  error: debug('libp2p:transports:err')
});

var pSettle = require('p-settle');

var _require = require('./errors'),
    codes = _require.codes;

var errCode = require('err-code');

var _require2 = require('./record/utils'),
    updateSelfPeerRecord = _require2.updateSelfPeerRecord;
/**
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('libp2p-interfaces/src/transport/types').TransportFactory<any, any>} TransportFactory
 * @typedef {import('libp2p-interfaces/src/transport/types').Transport<any, any>} Transport
 *
 * @typedef {Object} TransportManagerProperties
 * @property {import('./')} libp2p
 * @property {import('./upgrader')} upgrader
 *
 * @typedef {Object} TransportManagerOptions
 * @property {number} [faultTolerance = FAULT_TOLERANCE.FATAL_ALL] - Address listen error tolerance.
 */


var TransportManager = /*#__PURE__*/function () {
  /**
   * @class
   * @param {TransportManagerProperties & TransportManagerOptions} options
   */
  function TransportManager(_ref) {
    var libp2p = _ref.libp2p,
        upgrader = _ref.upgrader,
        _ref$faultTolerance = _ref.faultTolerance,
        faultTolerance = _ref$faultTolerance === void 0 ? FAULT_TOLERANCE.FATAL_ALL : _ref$faultTolerance;

    _classCallCheck(this, TransportManager);

    this.libp2p = libp2p;
    this.upgrader = upgrader;
    /** @type {Map<string, Transport>} */

    this._transports = new Map();
    this._listeners = new Map();
    this._listenerOptions = new Map();
    this.faultTolerance = faultTolerance;
  }
  /**
   * Adds a `Transport` to the manager
   *
   * @param {string} key
   * @param {TransportFactory} Transport
   * @param {*} transportOptions - Additional options to pass to the transport
   * @returns {void}
   */


  _createClass(TransportManager, [{
    key: "add",
    value: function add(key, Transport) {
      var transportOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      log('adding %s', key);

      if (!key) {
        throw errCode(new Error("Transport must have a valid key, was given '".concat(key, "'")), codes.ERR_INVALID_KEY);
      }

      if (this._transports.has(key)) {
        throw errCode(new Error('There is already a transport with this key'), codes.ERR_DUPLICATE_TRANSPORT);
      }

      var transport = new Transport(_objectSpread(_objectSpread({}, transportOptions), {}, {
        libp2p: this.libp2p,
        upgrader: this.upgrader
      }));

      this._transports.set(key, transport);

      this._listenerOptions.set(key, transportOptions.listenerOptions || {});

      if (!this._listeners.has(key)) {
        this._listeners.set(key, []);
      }
    }
    /**
     * Stops all listeners
     *
     * @async
     */

  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var tasks, _iterator, _step, _step$value, key, listeners, listener, _iterator2, _step2, _key;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tasks = [];
                _iterator = _createForOfIteratorHelper(this._listeners);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _step$value = _slicedToArray(_step.value, 2), key = _step$value[0], listeners = _step$value[1];
                    log('closing listeners for %s', key);

                    while (listeners.length) {
                      listener = listeners.pop();
                      listener.removeAllListeners('listening');
                      listener.removeAllListeners('close');
                      tasks.push(listener.close());
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _context.next = 5;
                return Promise.all(tasks);

              case 5:
                log('all listeners closed');
                _iterator2 = _createForOfIteratorHelper(this._listeners.keys());

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _key = _step2.value;

                    this._listeners.set(_key, []);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
    /**
     * Dials the given Multiaddr over it's supported transport
     *
     * @param {Multiaddr} ma
     * @param {*} options
     * @returns {Promise<Connection>}
     */

  }, {
    key: "dial",
    value: function () {
      var _dial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ma, options) {
        var transport;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                transport = this.transportForMultiaddr(ma);

                if (transport) {
                  _context2.next = 3;
                  break;
                }

                throw errCode(new Error("No transport available for address ".concat(String(ma))), codes.ERR_TRANSPORT_UNAVAILABLE);

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return transport.dial(ma, options);

              case 6:
                return _context2.abrupt("return", _context2.sent);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](3);
                if (!_context2.t0.code) _context2.t0.code = codes.ERR_TRANSPORT_DIAL_FAILED;
                throw _context2.t0;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));

      function dial(_x, _x2) {
        return _dial.apply(this, arguments);
      }

      return dial;
    }()
    /**
     * Returns all Multiaddr's the listeners are using
     *
     * @returns {Multiaddr[]}
     */

  }, {
    key: "getAddrs",
    value: function getAddrs() {
      /** @type {Multiaddr[]} */
      var addrs = [];

      var _iterator3 = _createForOfIteratorHelper(this._listeners.values()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var listeners = _step3.value;

          var _iterator4 = _createForOfIteratorHelper(listeners),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var listener = _step4.value;
              addrs = [].concat(_toConsumableArray(addrs), _toConsumableArray(listener.getAddrs()));
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return addrs;
    }
    /**
     * Returns all the transports instances.
     *
     * @returns {IterableIterator<Transport>}
     */

  }, {
    key: "getTransports",
    value: function getTransports() {
      return this._transports.values();
    }
    /**
     * Finds a transport that matches the given Multiaddr
     *
     * @param {Multiaddr} ma
     * @returns {Transport|null}
     */

  }, {
    key: "transportForMultiaddr",
    value: function transportForMultiaddr(ma) {
      var _iterator5 = _createForOfIteratorHelper(this._transports.values()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var transport = _step5.value;
          var addrs = transport.filter([ma]);
          if (addrs.length) return transport;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return null;
    }
    /**
     * Starts listeners for each listen Multiaddr.
     *
     * @async
     * @param {Multiaddr[]} addrs - addresses to attempt to listen on
     */

  }, {
    key: "listen",
    value: function () {
      var _listen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(addrs) {
        var _this = this;

        var couldNotListen, _iterator6, _step6, _step6$value, key, transport, supportedAddrs, tasks, _iterator7, _step7, addr, listener, results, isListening, message;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!addrs || addrs.length === 0)) {
                  _context3.next = 3;
                  break;
                }

                log('no addresses were provided for listening, this node is dial only');
                return _context3.abrupt("return");

              case 3:
                couldNotListen = [];
                _iterator6 = _createForOfIteratorHelper(this._transports.entries());
                _context3.prev = 5;

                _iterator6.s();

              case 7:
                if ((_step6 = _iterator6.n()).done) {
                  _context3.next = 24;
                  break;
                }

                _step6$value = _slicedToArray(_step6.value, 2), key = _step6$value[0], transport = _step6$value[1];
                supportedAddrs = transport.filter(addrs);
                tasks = []; // For each supported multiaddr, create a listener

                _iterator7 = _createForOfIteratorHelper(supportedAddrs);

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    addr = _step7.value;
                    log('creating listener for %s on %s', key, addr);
                    listener = transport.createListener(this._listenerOptions.get(key));

                    this._listeners.get(key).push(listener); // Track listen/close events


                    listener.on('listening', function () {
                      return updateSelfPeerRecord(_this.libp2p);
                    });
                    listener.on('close', function () {
                      return updateSelfPeerRecord(_this.libp2p);
                    }); // We need to attempt to listen on everything

                    tasks.push(listener.listen(addr));
                  } // Keep track of transports we had no addresses for

                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

                if (!(tasks.length === 0)) {
                  _context3.next = 16;
                  break;
                }

                couldNotListen.push(key);
                return _context3.abrupt("continue", 22);

              case 16:
                _context3.next = 18;
                return pSettle(tasks);

              case 18:
                results = _context3.sent;
                // If we are listening on at least 1 address, succeed.
                // TODO: we should look at adding a retry (`p-retry`) here to better support
                // listening on remote addresses as they may be offline. We could then potentially
                // just wait for any (`p-any`) listener to succeed on each transport before returning
                isListening = results.find(function (r) {
                  return r.isFulfilled === true;
                });

                if (!(!isListening && this.faultTolerance !== FAULT_TOLERANCE.NO_FATAL)) {
                  _context3.next = 22;
                  break;
                }

                throw errCode(new Error("Transport (".concat(key, ") could not listen on any available address")), codes.ERR_NO_VALID_ADDRESSES);

              case 22:
                _context3.next = 7;
                break;

              case 24:
                _context3.next = 29;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t0 = _context3["catch"](5);

                _iterator6.e(_context3.t0);

              case 29:
                _context3.prev = 29;

                _iterator6.f();

                return _context3.finish(29);

              case 32:
                if (!(couldNotListen.length === this._transports.size)) {
                  _context3.next = 37;
                  break;
                }

                message = "no valid addresses were provided for transports [".concat(couldNotListen, "]");

                if (!(this.faultTolerance === FAULT_TOLERANCE.FATAL_ALL)) {
                  _context3.next = 36;
                  break;
                }

                throw errCode(new Error(message), codes.ERR_NO_VALID_ADDRESSES);

              case 36:
                log("libp2p in dial mode only: ".concat(message));

              case 37:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 26, 29, 32]]);
      }));

      function listen(_x3) {
        return _listen.apply(this, arguments);
      }

      return listen;
    }()
    /**
     * Removes the given transport from the manager.
     * If a transport has any running listeners, they will be closed.
     *
     * @async
     * @param {string} key
     */

  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key) {
        var _iterator8, _step8, listener;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                log('removing %s', key);

                if (!this._listeners.has(key)) {
                  _context4.next = 21;
                  break;
                }

                // Close any running listeners
                _iterator8 = _createForOfIteratorHelper(this._listeners.get(key));
                _context4.prev = 3;

                _iterator8.s();

              case 5:
                if ((_step8 = _iterator8.n()).done) {
                  _context4.next = 13;
                  break;
                }

                listener = _step8.value;
                listener.removeAllListeners('listening');
                listener.removeAllListeners('close');
                _context4.next = 11;
                return listener.close();

              case 11:
                _context4.next = 5;
                break;

              case 13:
                _context4.next = 18;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](3);

                _iterator8.e(_context4.t0);

              case 18:
                _context4.prev = 18;

                _iterator8.f();

                return _context4.finish(18);

              case 21:
                this._transports.delete(key);

                this._listeners.delete(key);

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 15, 18, 21]]);
      }));

      function remove(_x4) {
        return _remove.apply(this, arguments);
      }

      return remove;
    }()
    /**
     * Removes all transports from the manager.
     * If any listeners are running, they will be closed.
     *
     * @async
     */

  }, {
    key: "removeAll",
    value: function () {
      var _removeAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var tasks, _iterator9, _step9, key;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                tasks = [];
                _iterator9 = _createForOfIteratorHelper(this._transports.keys());

                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    key = _step9.value;
                    tasks.push(this.remove(key));
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }

                _context5.next = 5;
                return Promise.all(tasks);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function removeAll() {
        return _removeAll.apply(this, arguments);
      }

      return removeAll;
    }()
  }]);

  return TransportManager;
}();
/**
 * Enum Transport Manager Fault Tolerance values.
 * FATAL_ALL should be used for failing in any listen circumstance.
 * NO_FATAL should be used for not failing when not listening.
 *
 * @readonly
 * @enum {number}
 */


var FAULT_TOLERANCE = {
  FATAL_ALL: 0,
  NO_FATAL: 1
};
TransportManager.FaultTolerance = FAULT_TOLERANCE;
module.exports = TransportManager;